module.exports = __webpack_public_path__ + "9a6ad7cbc6a4402fe599a5c24158616b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/gitaar_spelen.mp3
// module id = 67
// module chunks = 0